import React from "react";

import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";

import { Dayjs } from "dayjs";

export interface DateFieldProps {
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  error?: boolean;
  datePickerProps?: DatePickerProps<Dayjs>;
}

const DateField: React.FC<DateFieldProps> = ({
  value,
  onChange,
  error,
  datePickerProps,
}) => {
  return (
    <DatePicker
      format="YYYY-MM-DD"
      slotProps={{
        textField: {
          size: "small",
          placeholder: "ÅÅÅÅ-MM-DD",
          sx: {
            bgcolor: "background.paper",
          },
          error,
        },
        openPickerIcon: {
          sx: {
            fontSize: 20,
            color: "grey.500",
          },
        },
      }}
      slots={{
        openPickerIcon: CalendarTodayOutlinedIcon,
      }}
      value={value}
      onChange={onChange}
      {...datePickerProps}
    />
  );
};

export default DateField;
